import { render, staticRenderFns } from "./AddPromosTemplatesModal.vue?vue&type=template&id=effb9e90&"
import script from "./AddPromosTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./AddPromosTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports